<li [id]="id" [ngClass]="{'isImported':isImported}">
        
    <!-- the visual part -->
    <!-- [ngClass]="{isSelected:isSelected, isProject:folder.ref['isProject'], isFile:isFile, isFolder:!isFile, isPlottable:folder.ref['canPlot']}" -->

    <input *ngIf="isFile && folder.selectable" class="fdm-icon-action float-over" type="checkbox" (change)="onChecked($event.target.checked)">

    <label class="fdm-link" [ngClass]="{'fdm-sidebar-scene-header':!isFile, 'isSelected':isSelected}" (click)="clickMe();">

        <ng-container *ngIf="!isFile && hasChildren">
            <fa-icon *ngIf="expanded" [fixedWidth]="true" icon="caret-down"></fa-icon>
            <fa-icon *ngIf="!expanded" [fixedWidth]="true" icon="caret-right"></fa-icon>
        </ng-container>

        <b><fa-icon class="fdm-silent-icon" [icon]="folder.icon ? folder.icon : ( isFile ? 'file': (expanded?'folder-open':'folder'))"></fa-icon></b>

        <b class="title">{{ folder.caption }}</b>

        <ng-container *ngIf="!isFile">
            <fa-icon icon="info-circle" class="fdm-link ml-2" (click)="clicked();$event.stopPropagation();"></fa-icon>
        </ng-container>

    </label>

    <!-- children -->
    <ul *ngIf="expanded">
        <folder-node *ngFor="let cur of children" [folder]="cur" [_selectedFolder]="_selectedFolder"  (change)="change.emit($event)"></folder-node>
    </ul>
    
</li>